export default __webpack_public_path__ + "b802bfcf6c901517bc243058329ef276.svg";